// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3biOF","col":"styles_col__2jvN9"};